// extracted by mini-css-extract-plugin
export default {"leftStickyCell":"StickyTable_leftStickyCell__xSahH","cell":"StickyTable_cell__VE1Lv","rightStickyCell":"StickyTable_rightStickyCell__Tg1Iz"};